/**
 * Firestore のセキュリティルールで読み取りを拒否されたエラーか
 *
 * compat / modular どちらの SDK のエラーも code を持つので、クラスではなく code で判定する。
 */
export const isPermissionDeniedError = (
  error: unknown
): error is { code: "permission-denied" } =>
  typeof error === "object" &&
  error !== null &&
  "code" in error &&
  error.code === "permission-denied";
